// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3XqKt","focado":"OptionSelect_focado__2BpDw"};